var lory: LoryStatic = require('lory.js').lory;

(window as any).initCarousel = function (carouselId: string, slidesToScrollNum: number) {
    const carouselItem = document.getElementById(carouselId);
    const slidesToScrollAtOnce = slidesToScrollNum ? slidesToScrollNum : 1; 
    const infiniteBuffer = slidesToScrollNum ? slidesToScrollNum : 2;

    if (carouselItem) {
        const loryOptions: LoryOptions = {
            enableMouseEvents: true,
            infinite: infiniteBuffer,
            slideSpeed: 1000,
            slidesToScroll: slidesToScrollAtOnce,
            ease: 'cubic-bezier(0, 0, 1, 1)'
        };

        let dot_count = carouselItem.querySelectorAll('.js_slide').length / slidesToScrollAtOnce;
        let dot_container = carouselItem.querySelector('.js_dots');
        let dot_list_item = document.createElement('li');
        let nextBtn = carouselItem.querySelector('.js_next') as HTMLElement;
        let prevBtn = carouselItem.querySelector('.js_prev') as HTMLElement;
        dot_list_item.tabIndex = 0;

        function handleDotEvent(e) {
            if (e.type === 'before.lory.init') {
                for (var i = 0, len = dot_count; i < len; i++) {
                    var clone = dot_list_item.cloneNode() as HTMLElement;
                    clone.innerHTML = `<span class="visually-hidden">Select slide ${i + 1}`;
                    dot_container.appendChild(clone);
                }
                dot_container.children[0].classList.add('active');
            }
            if (e.type === 'after.lory.init') {
                for (var i = 0, len = dot_count; i < len; i++) {
                    dot_container.children[i].addEventListener('click', evt => {
                        if (Array.prototype.indexOf.call(dot_container.children, evt.target) != 0) {
                            carouselContainer.slideTo(Array.prototype.indexOf.call(dot_container.children, evt.target) + (slidesToScrollAtOnce - 1));
                        }
                        else {
                            carouselContainer.slideTo(Array.prototype.indexOf.call(dot_container.children, evt.target));
                        }
                    });
                    dot_container.children[i].addEventListener('keyup', (evt: KeyboardEvent) => {
                        if (evt.which == 13) {
                            if (Array.prototype.indexOf.call(dot_container.children, evt.target) != 0) {
                                carouselContainer.slideTo(Array.prototype.indexOf.call(dot_container.children, evt.target) + (slidesToScrollAtOnce - 1));
                            }
                            else {
                                carouselContainer.slideTo(Array.prototype.indexOf.call(dot_container.children, evt.target));
                            }
                        }
                    });
                }
                nextBtn.addEventListener('keyup', (evt: KeyboardEvent) => {
                    if (evt.which == 13) {
                        carouselContainer.next();
                    }
                });
                prevBtn.addEventListener('keyup', (evt: KeyboardEvent) => {
                    if (evt.which == 13) {
                        carouselContainer.prev();
                    }
                });
            }
            if (e.type === 'after.lory.slide') {
                for (var i = 0, len = dot_container.children.length; i < len; i++) {
                    dot_container.children[i].classList.remove('active');
                }
                dot_container.children[(e.detail.currentSlide - infiniteBuffer + dot_count) % dot_count].classList.add('active'); //complex to reference because of the "infinite" thing
            }
            if (e.type === 'on.lory.resize') {
                for (var i = 0, len = dot_container.children.length; i < len; i++) {
                    dot_container.children[i].classList.remove('active');
                }
                dot_container.children[0].classList.add('active');
            }
        }
        carouselItem.addEventListener('before.lory.init', handleDotEvent);
        carouselItem.addEventListener('after.lory.init', handleDotEvent);
        carouselItem.addEventListener('after.lory.slide', handleDotEvent);
        carouselItem.addEventListener('on.lory.resize', handleDotEvent);

        let carouselContainer = lory(carouselItem, loryOptions);
        /* Automatic transition 
               Dev Notes: The transition speed is the property available only for the home page carousel.
               This property is used as a condition to automate the carousel rotation.
        */
        var transitionSpeed = carouselItem.getAttribute("data-transition-speed");
        if (transitionSpeed != null) {
            var notDesktop = window.innerWidth <= 768;
            if (notDesktop) {
                window.cancelAnimationFrame(reqAnimation);
            }
            else {
                var autoSlide, interval, startTime, currentTime, elapsed, reqAnimation;
                var playPause = document.getElementById("carouselPlayPauseJS");
                var playPauseSvg = playPause.querySelector("svg use");
                var sliderButton = document.querySelector(".carousel-buttons-inner-js");

                startAnimating(transitionSpeed);

                function startAnimating(speed) {
                    interval = (speed * 1000);
                    autoSlide = true;
                    sliderButton.addEventListener('click', (e) => {
                        autoSlide = false;
                        startTime = Date.now();
                        nextSlide();
                    });

                    if (autoSlide) {
                        startTime = Date.now();
                        animate();
                    }
                }

                function animate() {
                    reqAnimation = requestAnimationFrame(animate);
                    nextSlide();
                }

                function nextSlide() {
                    currentTime = Date.now();
                    elapsed = currentTime - startTime;

                    if (elapsed > interval) {
                        startTime = currentTime - (elapsed % interval);
                        carouselContainer.next();
                    }
                }

                playPause.addEventListener('click', (e) => {
                    var xlinkHref = 'xlink:href';
                    var svg = playPauseSvg.getAttribute(xlinkHref);
                    var playPauseElement = document.getElementById("playPauseTextJS")
                    var playPauseText: string;
                    if (svg.indexOf('play') != -1) {
                        startAnimating(transitionSpeed);
                        playPauseSvg.setAttribute(xlinkHref, "#icon-pause");
                        playPauseText = "Stop automatic transition";
                    }
                    else {
                        window.cancelAnimationFrame(reqAnimation);
                        playPauseSvg.setAttribute(xlinkHref, "#icon-play");
                        playPauseText = "Start automatic transition";
                    }
                    playPauseElement.innerHTML = playPauseText;
                });
            }
        }
    }
}


// WEBPACK FOOTER //
// ./node_modules/source-map-loader!./Static/javascript/modules/carousel-init.ts